import { matchPath, PathPattern, useLocation } from "react-router-dom";


// TODO can't seem to import these from their route definitions... :( circular dependencies maybe?
const dataRoutes: (string | PathPattern)[] = [
  "/home",
  {
    path: "/billing/:tab",
    end: false
  },
  {
    path: "/billing",
    end: false
  }
];

export function useRelativeModalPathsForDataRoutes(
  path: string
) {
  const location = useLocation();

  for (const route of dataRoutes) {
    const match = matchPath(route, location.pathname);
    if (match) return match.pathnameBase + path;
  }
  return path;
}
